const ROLEADMIN_COLUMNS = [
  {
    title: '姓名',
    dataIndex: 'realName',
    key: 'realName'
  },
  {
    title: '手机号码',
    dataIndex: 'mobile',
    key: 'mobile'
  },
  {
    title: '邮箱',
    dataIndex: 'email',
    key: 'email'
  }
];

export { ROLEADMIN_COLUMNS };
